import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { take, shuffle, uniqBy } from 'lodash/fp'
import { FC } from 'react'
import { CreatorFeatureWithUsernameAndImage } from 'shared/src/api/types'
import { addPropIdentityStabilization } from 'ad-hok-utils'
import { flow } from 'lodash'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { makeFluidCreatorUrl } from 'utils/routes'
import { Feature, FeedFeature } from 'components/FeedFeature'

const randomizeFeatures: (
  features: CreatorFeatureWithUsernameAndImage[]
) => CreatorFeatureWithUsernameAndImage[] = flow(
  shuffle,
  uniqBy('userId'),
  take(4)
)

interface Props {
  creatorFeatures: CreatorFeatureWithUsernameAndImage[]
  className?: string
}

export const CreatorFeatures: FC<Props> = flowMax(
  addDisplayName('CreatorFeatures'),
  addPropIdentityStabilization('creatorFeatures'),
  addProps(
    ({ creatorFeatures }) => ({
      features: randomizeFeatures(creatorFeatures).map(
        ({ username, image }): Feature => ({
          image,
          navigateTo: makeFluidCreatorUrl(username),
          alt: username ?? '',
        })
      ),
    }),
    ['creatorFeatures']
  ),
  addTranslationHelpers,
  ({ features, className, t }) => (
    <FeedFeature
      name={t('menu.featured')}
      features={features}
      className={className}
    />
  )
)
